import { createContext, useContext, useState } from 'react';
import { Snackbar, Alert, AlertTitle } from '@mui/material';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
    severity: 'info',
    title: '',
  });

  const showAlert = (message, severity = 'info', title = '') => {
    setAlertState({
      open: true,
      message,
      severity,
      title,
    });
  };

  const closeAlert = () => {
    setAlertState({ ...alertState, open: false });
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}

      <Snackbar
        open={alertState.open}
        autoHideDuration={4000}
        onClose={closeAlert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          severity={alertState.severity}
          variant="filled"
          onClose={closeAlert}
          sx={{
            width: '100%',
            minWidth: 350,
            maxWidth: 700,
          }}
        >
          {alertState.title && <AlertTitle>{alertState.title}</AlertTitle>}
          {alertState.message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
